import {
  isBlockquote,
  isHeading,
  isLink,
  isParagraph,
} from "datocms-structured-text-utils"
import { Heading as DatoHeading } from "datocms-structured-text-utils/dist/types/types"
import React from "react"
import { renderNodeRule } from "react-datocms"
import { QuoteProps } from "../components/quote/Quote"
import { Paragraph, ParagraphProps } from "../components/paragraph/Paragraph"
import { Heading } from "../components/heading/Heading"
import { HeadingTextSize, HeadingTextWeight } from "../util/styles/theme"

export const omitParagraphTagRenderRule = renderNodeRule(
  isParagraph,
  ({ children }) => {
    // Return only children (= omit p tag)
    return children
  },
)

export const paragraphRenderRule = (props: ParagraphProps) =>
  renderNodeRule(isParagraph, ({ children, key }) => {
    return (
      <Paragraph {...props} key={key}>
        {children}
      </Paragraph>
    )
  })

export type headingRenderRuleLevels = DatoHeading["level"] | "default"
export const headingRenderRule = (
  levelToStyles: Partial<
    Record<
      headingRenderRuleLevels,
      { size: HeadingTextSize; weight: HeadingTextWeight }
    >
  >,
) =>
  renderNodeRule(isHeading, ({ children, key, node }) => {
    const asTag = `h${node.level}` as never

    const level = levelToStyles[node.level] ?? levelToStyles.default

    return (
      <Heading as={asTag} key={key} {...level}>
        {children}
      </Heading>
    )
  })

export const linkRenderRule = (
  LinkComponent: React.FC<
    React.DetailedHTMLProps<
      React.AnchorHTMLAttributes<HTMLAnchorElement>,
      HTMLAnchorElement
    >
  >,
) =>
  renderNodeRule(isLink, ({ children, key, node }) => {
    const target = node.meta?.find(m => m.id === "target")?.value

    return (
      <LinkComponent key={key} href={node.url} target={target}>
        {children}
      </LinkComponent>
    )
  })

export const blockquoteRenderRule = (QuoteComponent: React.FC<QuoteProps>) =>
  renderNodeRule(isBlockquote, ({ children, key, node }) => {
    return (
      <QuoteComponent key={key} attribution={node.attribution}>
        {children}
      </QuoteComponent>
    )
  })
